import { put, takeLatest, all, call, select } from 'redux-saga/effects'
import { getCurrentCountry, countryCode, getConfigKey } from 'utils/appUtils'
import { language } from 'context/LanguageContext/strings'
import { actions, getConfigurationSuccess, getConfigurationFailed } from './actions'
import { configurationURL } from './urls'
import parseConfiguration from './index'
import { api } from '../../network/api'
import { getItemIfHashCodeMatches, setItem } from '../../utils/storageUtils'

export function* getConfiguration(action) {
    try {
        const { location, user } = yield select()
        const reqObj = {
            app: '7NOW',
            type: 'global',
            version: '1.0',
            country: action.country
                ? action.country
                : getCurrentCountry(location, user) === countryCode.CA
                  ? 'CA'
                  : 'US',
            last_modified_date: '',
        }
        const configurationRequestCall = yield call(
            api,
            configurationURL,
            'POST',
            reqObj,
            1,
            null,
            false,
            language
        )
        if (!configurationRequestCall.configurations) {
            throw new Error(configurationRequestCall.message || 'No data found')
        }
        const parsedConfiguration = parseConfiguration(configurationRequestCall)
        // Validating the API response and formatting it
        yield put(getConfigurationSuccess(parsedConfiguration))

        return parsedConfiguration
    } catch (error) {
        yield put(getConfigurationFailed(error))
    }
}

function* getConfigurationWatcher() {
    yield takeLatest(actions.GET_CONFIGURATION, getConfiguration)
}

export default function* configurationSaga() {
    yield all([getConfigurationWatcher()])
}
